import { SectionHeader } from "@/components/common/section-components/SectionHeader";
import { TabComponent } from "@/components/tabs/TabComponent";
import { Flex } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRoles } from "@/hooks/useRoles";
import { UploadTaxesTab } from "./components/upload-taxes/UploadTaxesTab";
import { LoadedTaxesTab } from "./components/upload-taxes/LoadedTaxesTab";

export const TaxesPage = () => {
    const [loadingLoadedTaxes, setLoadingLoadedTaxes] = useState(false);
  const navigate = useNavigate();
  const { fetchPermissions } = useRoles();

  const [currentTab, setCurrentTab] = useState<string>("SubirArchivo");
  return (
    <Flex flexDir="column" paddingTop="20px" gap="30px" data-testid="taxes-page">
      <SectionHeader title="Impuestos" showButtons={false} loading={loadingLoadedTaxes}/>

      <TabComponent
        value={currentTab}
        onValueChange={(value) => setCurrentTab(value.value)}
        tabs={[
          {
            label: "Subir Archivo",
            value: "SubirArchivo",
            content: (
              <UploadTaxesTab
                navigate={navigate}
                fetchPermissions={fetchPermissions}
                setCurrentTab={setCurrentTab}
              />
            ),
          },
          {
            label: "Impuestos Cargados",
            value: "ImpuestosCargados",
            content: (
              <LoadedTaxesTab
                navigate={navigate}
                fetchPermissions={fetchPermissions}
                currentTab={currentTab}
                loadingTaxes={loadingLoadedTaxes}
                setLoadingTaxes={setLoadingLoadedTaxes}
              />
            ),
          },
        ]}
      />
    </Flex>
  );
};
